import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Oras pero sientes que el desorden mental o la ansiedad no desaparecen', 'Quieres un método práctico de fe que funcione en menos de 15 min/día', 'Deseas mejorar tu relación con el dinero desde gratitud, paz y mayordomía', 'Eres cristiano(a) o católico(a) y quieres herramientas alineadas con tu fe', 'Has intentado antes pero necesitas estructura, constancia y acompañamiento real'];
  const notForYou = ['Buscas resultados mágicos sin compromiso diario ni esfuerzo personal', 'Esperas que en 30 días todos tus problemas financieros desaparezcan solos', 'No estás dispuesto(a) a dedicar 10–15 minutos al día a tu proceso interior', 'Buscas asesoría médica, psicológica, legal o financiera profesional', 'Quieres una promesa de riqueza rápida sin fe, orden ni acción obediente'];
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-105">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-107">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-108">
            Este programa es para ti si…
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-109">
            <div className="bg-white rounded-lg p-8 shadow-md" data-id="element-110">
              <h3 className="text-2xl font-serif font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-111">
                <Check className="w-6 h-6" data-id="element-112" />
                SÍ es para ti si
              </h3>
              <ul className="space-y-4" data-id="element-113">
                {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-114">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-115" />
                    <span className="text-dark/80" data-id="element-116">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-md" data-id="element-117">
              <h3 className="text-2xl font-serif font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-118">
                <X className="w-6 h-6" data-id="element-119" />
                NO es para ti si
              </h3>
              <ul className="space-y-4" data-id="element-120">
                {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-121">
                    <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-122" />
                    <span className="text-dark/80" data-id="element-123">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-lg" data-id="element-124">
            <p className="text-dark/80" data-id="element-125">
              ⚠️{' '}
              <em data-id="element-126">
                Este material tiene propósito espiritual y educativo. No
                sustituye asesoría profesional de ningún tipo.
              </em>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}